import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CatalogInfo } from '@shared/models/shared-catalog.state';
import { SharedCatalogState } from '@shared/state/catalog/shared-catalog.state';
import { setLocationQueryParams } from '@utils/other-utils';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { CatalogItemsQueryParams } from '../../models/catalog-item-component';
import { SetIsDynamic } from '../../store/catalog-items.actions';
import { CatalogItemsState } from '../../store/catalog-items-state';

@Component({
  selector: 'app-catalog-description',
  templateUrl: './catalog-description.component.html',
  styleUrls: ['./catalog-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogDescriptionComponent implements OnInit {
  private _isDynamic: boolean;
  @Select(SharedCatalogState.catalogInfo) public selectCatalogInfo$: Observable<CatalogInfo>;

  constructor(private activeRoute: ActivatedRoute, private store: Store, private router: Router, private location: Location) {}

  private getStoreParams(): void {
    const params = this.activeRoute.snapshot.queryParams as CatalogItemsQueryParams;

    if (params?.isDynamic && params.isDynamic === 'true') {
      this._isDynamic = true;
      this.store.dispatch(new SetIsDynamic(this._isDynamic, false));
    } else {
      const catalogId = this.store.selectSnapshot(SharedCatalogState.selectCatalog)?.id;
      if (catalogId) {
        const currentCatalogItem = this.store.selectSnapshot(CatalogItemsState.getCatalogItem).call(this, catalogId);

        if (currentCatalogItem) {
          if (currentCatalogItem.isDynamic !== undefined) {
            this._isDynamic = currentCatalogItem.isDynamic;
            setLocationQueryParams({ isDynamic: this._isDynamic }, this.router, this.location);
          }
        }
      }
    }
  }

  public ngOnInit(): void {
    this.getStoreParams();
  }
}
